function getPlatformUrl(platform?: string, orderId?: string) {
	if (platform === "去哪儿") {
		return `QunariPhone://flight/orderDetail?domain=&orderNo=${orderId}&otaType=5&refer=2&cat=tc-orderlist-wirelessList&jumpNewOd=true&newOdVersion=30`;
	}
	if (platform === "携程") {
		return `ctrip://wireless/flight_h5_rn_handle?pagetype=orderdetail&oid=${orderId}&channel=myctrip&isfltshare=1&isfltwake=1`;
	}
	if (platform === "Trip") {
		return `ctripglobal://FlightOrderDetail?channel=bookings&subChannel=tripcard&accesstoken=&opentype=&orderId=&source=bookings&oid=${orderId}`;
	}
	if (platform === "同程") {
		return `tctclient://web/main?url=${encodeURIComponent(`https://app.ly.com/appiflight/orderDetail.html/${orderId}?wv_viewport=1`)}`;
	}

	return undefined;
}

export default getPlatformUrl;
